import styled from "@emotion/styled";

export const StyledFilters = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
}));

export const MultiSelection = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));

export const StyledButtonsWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
}));
